import { createFileRoute } from '@tanstack/react-router';
import { ParentWorkspaceRoute } from '@/features/parent/ui/ParentWorkspaceRoute';

import { requireRole } from '@/lib/routeGuards';

/** Layout-гард кабинета родителя: /parent/* доступен только parent. */
export const Route = createFileRoute('/_authed/parent')({
  beforeLoad: () => requireRole('parent'),
  validateSearch: (search): { child?: string } => ({
    child: typeof search.child === 'string' ? search.child : undefined,
  }),
  component: ParentWorkspaceRoute,
});
